import React from 'react';
import { useObserver } from 'mobx-react-lite';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import type { Dispensaries } from 'src/gql/graphql';

import JsonLDScript from './json-ld/json-id-script';
import Meta from './meta';

export default function DispensaryTags(): JSX.Element | null {
  const { dispensary } = useDispensary() as { dispensary?: Dispensaries | null };
  const listImage = useObserver(() => dispensary?.listImage);
  const dispensaryNotActive = dispensary?.status !== 'open';

  if (!dispensary) {
    return null;
  }

  return (
    <>
      <Meta property='og:image' content={listImage} />
      {dispensaryNotActive && (
        <>
          <Meta property='robots' content='noindex,nofollow' />
          <Meta property='googlebot' content='noindex,nofollow' />
        </>
      )}
      <JsonLDScript variant='dispensary' jsonLdData={dispensary} />
    </>
  );
}
